import * as React from "react"
import styles from "./InfoTooltip.module.scss"
import { Trans, useTranslation } from "react-i18next"
import { Card } from "reactstrap"

export const InfoTooltip = ({ content }: { content: string }) => {
  const { t } = useTranslation()
  return <Card className={styles.container}>
    <Trans i18nKey={content} t={t} />
  </Card>
}